import { createApp } from 'vue';
import './style.css';
import App from './App.vue';

const app = createApp(App);

if (import.meta.env.PROD) {
  void import('@sentry/vue').then(Sentry => {
    Sentry.init({
      app,
      dsn: 'https://50ee9ca6df4fa614791a4c55fdbc9984@o1418389.ingest.us.sentry.io/4511164339978240',
      sendDefaultPii: true,
      integrations: [Sentry.replayIntegration()],
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });
  });
}

app.mount('#app');
